(() => {
  if (window.suncoApplicationPagesInitialized) return;

  window.suncoApplicationPagesInitialized = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const setExpanded = (section, expanded) => {
    const toggle = section.querySelector('[data-sunco-reviews-toggle]');
    const label = section.querySelector('[data-sunco-reviews-toggle-label]');
    const expandLabel = section.dataset.suncoMobileExpandLabel || 'Show more testimonials';
    const collapseLabel = section.dataset.suncoMobileCollapseLabel || 'Show fewer testimonials';

    section.classList.toggle('is-expanded', expanded);

    if (toggle) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    if (label) {
      label.textContent = expanded ? collapseLabel : expandLabel;
    }
  };

  const measureReviews = (section) => {
    const viewport = section.querySelector('[data-sunco-reviews-viewport]');
    const cards = Array.from(section.querySelectorAll('[data-sunco-review-card]'));
    const toggle = section.querySelector('[data-sunco-reviews-toggle]');
    const fullCards = Number(section.dataset.suncoMobileCollapsedCards || 2);
    const previewCard = cards[fullCards];

    if (!viewport || !toggle || !mobileQuery.matches || !previewCard) {
      section.classList.remove('is-collapsible-ready');
      return;
    }

    const collapsedHeight = Math.ceil(previewCard.offsetTop + previewCard.offsetHeight / 3);

    section.style.setProperty('--sunco-reviews-mobile-collapsed-height', `${collapsedHeight}px`);
    section.classList.add('is-collapsible-ready');
  };

  const initSection = (section) => {
    const toggle = section.querySelector('[data-sunco-reviews-toggle]');

    if (!toggle || toggle.dataset.suncoReviewsBound === 'true') return;

    toggle.dataset.suncoReviewsBound = 'true';
    toggle.addEventListener('click', () => {
      const expanded = !section.classList.contains('is-expanded');

      setExpanded(section, expanded);
      measureReviews(section);

      if (!expanded && mobileQuery.matches) {
        section.scrollIntoView({ block: 'start' });
      }
    });

    setExpanded(section, false);
    measureReviews(section);
  };

  const refresh = () => {
    document.querySelectorAll('[data-sunco-reviews-section]').forEach((section) => {
      initSection(section);
      measureReviews(section);
    });
  };

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('resize', refresh, { passive: true });

  refresh();
})();
